import React, { memo, useMemo, useCallback, Fragment, useEffect } from 'react';
import { Chart, Interval, Legend, Axis, Coordinate, Annotation, Point } from 'bizcharts';
import { handleRawData } from './base';

/*/ 数据源
rawData: RawData;
// 在漏斗图上的展示顺序
order: string[];
// 漏斗转化率的映射表，用于取值自定义计算
funnelRatioMap: FunnelRatioMap;
// 漏斗跨行label展示转化率的映射表，用于取值自定义计算
funnelGapRatioMap: FunnelRatioMap;

// 左侧浅色颜色配置
lightColor?: string[];
// 漏斗图颜色配置
darkColor?: string[];
*/

/**
 * 漏斗图最右侧label折线绘制
 *
 * //左上角是-0.5 0右上角是-0.5 82
 * 左边是原来x轴的反的最小是-0.5从上往下递增
 * 下边是原来的y轴从左到右增加
 */
// eslint-disable-next-line react/display-name
const DataFunnelLabelLine = memo(({ startX, endX, startY, endY, lineColor, labelContent, index, skuOffset }) => {
  return (
    <Fragment>
      <Annotation.Line
        start={[startX, startY]}
        end={[startX, endY]}
        style={{
          lineWidth: 2,
          stroke: lineColor,
        }}
        text={{
          position: 'center',
          offsetY: skuOffset ? skuOffset : 46,
          content: labelContent,
          autoRotate: false,
          style: {
            textAlign: 'center',
            // fill: '#333',
          },
          // ...textStyle,
        }}
      />
      <Annotation.Line
        start={[startX, endY]}
        end={[endX, endY]}
        style={{
          lineWidth: 2,
          stroke: lineColor,
        }}
      />
      <Annotation.Line
        start={[endX, startY]}
        end={[endX, endY]}
        style={{
          lineWidth: 2,
          stroke: lineColor,
        }}
      />
    </Fragment>
  );
});

/**
 * 漏斗图最右侧label
 */
// eslint-disable-next-line react/display-name
const DataFunnelLabel = memo(({ obj, index }) => {
  const { funnelRange, funnelMaskEnd } = obj;
  // 绘制label线X轴开始基点
  // const startXBase = useMemo(() => {
  //   return (funnelRange[1] - funnelRange[0]) / 3;
  // }, [funnelRange]);
  const startXBase = 62;

  // 绘制label内容
  // const labelContent = useMemo(() => {
  //   return funnelLabel(obj);
  // }, [funnelLabel, obj]);

  return (
    <Fragment>
      {/* {index === 1 ? (
        <DataFunnelLabelLine
          startX={index}
          index={index}
          endX={1 + index}
          startY={startXBase}
          endY={startXBase + 30}
          lineColor="#D1E3FF"
          labelContent={obj.labelContent}
          isGapLine={false}
        />
      ) : ( */}
      <DataFunnelLabelLine
        index={index}
        startX={index}
        endX={0.9 + index}
        startY={77}
        endY={110}
        lineColor="#D1E3FF"
        labelContent={obj.labelContent}
        isGapLine={false}
      />
      {/* )} */}
    </Fragment>
  );
});

/**
 * 漏斗图最右侧label三个数据
 */
// eslint-disable-next-line react/display-name
const DataFunnelLabelAct = memo(({ obj, index }) => {
  const { funnelRange, funnelMaskEnd } = obj;

  const startXBase = 65;

  return (
    <Fragment>
      {index === 1 ? (
        <DataFunnelLabelLine
          index={index}
          startX={index - 1.2}
          endX={0.9 + index}
          startY={82}
          endY={110}
          lineColor="#D1E3FF"
          labelContent={obj.labelContent}
          isGapLine={false}
          skuOffset={180}
        />
      ) : (
        <DataFunnelLabelLine
          index={index}
          startX={index}
          endX={0.9 + index}
          startY={82}
          endY={105}
          lineColor="#D1E3FF"
          labelContent={obj.labelContent}
          isGapLine={false}
        />
      )}
    </Fragment>
  );
});

/**
 * 漏斗图最右侧label折线绘制会场的
 *
 * //左上角是-0.5 0右上角是-0.5 82
 * 左边是原来x轴的反的最小是-0.5从上往下递增
 * 下边是原来的y轴从左到右增加
 */
// eslint-disable-next-line react/display-name
const DataFunnelLabelLineAct = memo(({ startX, endX, startY, endY, lineColor, labelContent, index, textStyle }) => {
  return (
    <Fragment>
      <Annotation.Line
        start={[startX, startY]}
        end={[startX, endY]}
        style={{
          lineWidth: 2,
          stroke: lineColor,
        }}
      />
      <Annotation.Line
        start={[startX, endY]}
        end={[endX, endY]}
        style={{
          lineWidth: 2,
          stroke: lineColor,
        }}
        text={index !== 0 && { ...textStyle }}
      />
      <Annotation.Line
        start={[endX, startY]}
        end={[endX, endY]}
        style={{
          lineWidth: 2,
          stroke: lineColor,
        }}
        text={index === 0 && { ...textStyle }}
      />
    </Fragment>
  );
});

/**
 * 漏斗信息展示
 */
// eslint-disable-next-line react/display-name
const DataFunnelInfo = memo(({ valueStyle, titleStyle, info, obj, index, baseStyle, title, desc }) => {
  return (
    <Fragment>
      <Annotation.Text
        offsetX={40}
        // offsetY={15}
        position={{
          name: obj.name,
          funnelMaskEnd: 0,
        }}
        // position={[index + 0.05, 10]}
        content={desc}
        style={Object.assign({}, baseStyle)}
      />
      <Annotation.Text
        offsetX={120}
        // offsetY={15}
        position={{
          name: obj.name,
          funnelMaskEnd: 0,
        }}
        // position={[index + 0.05, 10]}
        content={title}
        style={Object.assign({}, titleStyle)}
      />
      <Annotation.Text
        offsetX={120}
        offsetY={10}
        position={{
          name: obj.name,
          funnelMaskEnd: 0,
        }}
        // position={[index + 0.05, 10]}
        content={info}
        style={Object.assign({}, valueStyle)}
      />
    </Fragment>
  );
});

const SkuDataFunnel = (props) => {
  const { rawData, order, lightColor, darkColor, isSku = false } = props;
  // 数据处理
  const data = useMemo(() => {
    return handleRawData(rawData, order);
  }, [rawData, order]);

  // 漏斗及蒙层的最值
  const scale = useMemo(() => {
    return {
      funnelMaskEnd: {
        min: 0, // 定义数值范围的最小值
        max: data.rangeEnd, // 定义数值范围的最大值
      },
      funnelRange: {
        min: 0, // 定义数值范围的最小值
        max: data.rangeEnd, // 定义数值范围的最大值
      },
    };
  }, [data]);

  return (
    <div className="data-effect">
      <Chart
        height={280}
        autoFit
        data={data.list}
        interactions={['active-region']}
        padding={[1, 2, 2, 2]}
        scale={scale}
        animate={false}
        // animate="grow-in-y"
      >
        <Coordinate scale={[1, -1]} transpose />
        <Legend visible={false} />
        <Axis visible={false} />
        {/* 左侧信息展示 */}
        {data.list.map((obj, index) => {
          // 左侧底板图层 title
          const title = `${obj.name}\n`;
          // 左侧底板图层 desc
          const desc = `${obj.desc}`;
          // 展示的详细信息
          const info = `\n${obj.value ? obj.value : '-'}`;

          // 左侧底板图层 title
          const image = `${obj.image}`;

          // 文案样式
          const baseStyle = {
            fill: obj.textColor,
            fontSize: '16',
            textAlign: 'left',
            lineHeight: '17',
          };
          //标题
          const titleStyle = {
            fill: 'rgba(0, 0, 0, 0.45)',
            fontSize: '12',
            lineHeight: '16',
          };
          //值
          const valueStyle = {
            fill: 'rgba(0, 0, 0, 0.65)',
            fontSize: '18',
            lineHeight: '22',
          };

          return (
            <Fragment key={`FunnelInfo${index}`}>
              <DataFunnelInfo
                key={obj.id}
                image={image}
                desc={desc}
                offsetX={20}
                index={index}
                obj={obj}
                title={title}
                info={info}
                baseStyle={baseStyle}
                titleStyle={titleStyle}
                valueStyle={valueStyle}
              />
              {/* 如果不是漏斗最后一行，则渲染每层的漏斗Label，用于展示转化率 */}
              {isSku
                ? index !== data.list.length - 1 && <DataFunnelLabelAct obj={obj} index={index} />
                : index !== data.list.length - 1 && <DataFunnelLabel obj={obj} index={index} />}
              {/* {index !== data.list.length - 1 && <DataFunnelLabel obj={obj} index={index} />} */}
              {/* {<DataFunnelLabel obj={obj} index={index} />} */}
            </Fragment>
          );
        })}

        {/* 左侧底板图层，用于展示数据信息 */}
        <Interval shape="funnel" position="name*funnelMaskEnd" tooltip={false} color={['name', lightColor]} />

        {/* 漏斗图 */}
        <Interval
          shape="funnel"
          top
          position="name*funnelRange"
          adjust="symmetric"
          tooltip={false}
          color={['name', darkColor]}
        />
      </Chart>
    </div>
  );
};
export default SkuDataFunnel;
